module.exports = __webpack_public_path__ + "static/img/cont33.68e679c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/cont33.jpg
// module id = pf5t
// module chunks = 1